export const UNAPPROVED_TRIP_ADVANCE = 11;
export const VEHICLE_UNALLOTTED = 7;
export const VENDOR_UNALLOTTED = 4;